module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dialog/dialog.component.css
// module id = ./src/app/shared/components/dialog/dialog.component.css
// module chunks = main